import styled from 'styled-components'
import { tertiaryYellow, white, white2 } from 'tcp-common/lib/colors'
import Flex from 'tcp-common/lib/components/Flex'
import { greyBackgroundGradient } from 'tcp-common/lib/gradient'

export const MainWrapper = styled(Flex)`
background-color: ${greyBackgroundGradient};

@media (min-width: 768px) {
    margin: auto; 
}
`
export const MainContent = styled(Flex)`

padding-right: 31px;
background: ${greyBackgroundGradient};
border-radius: 20px;
@media (max-width: 768px) {
    margin-right: 0;
    margin-top: 24px;
}
`
export const CardHeader = styled.span`
font-weight: 600;
font-size: 35px;
line-height: 24px;
color: ${white};
margin: 40px 0 0 40px;
@media (max-width: 768px) {
    margin: 24px 0 0 16px;
    font-size: 24px;
    line-height: 29px;
}
`
export const CardFee = styled.span`
font-weight: 400;
font-size: 24px;
line-height: 32px;
color: ${white2};
margin: 50px 0 0 40px;
@media (max-width: 768px) {
    margin: 24px 0 0 16px;
    font-size: 20px;
    line-height: 24px;
}
`
export const CardAmount = styled.span`
font-weight: 500;
font-size: 32px;
line-height: 24px;
color: ${tertiaryYellow};
margin: 16px 0 0 40px;
@media (max-width: 768px) {
    margin: 8px 0 0 16px;
    font-size: 24px;
    line-height: 24px;
}
`
export const CardCredited = styled.span`
font-weight: 400;
font-size: 24px;
line-height: 32px;
color: ${white2};
margin: 32px 0 0 40px;
@media (max-width: 768px) {
    margin: 24px 0 0 16px;
    font-size: 20px;
    line-height: 24px;
}
`
export const CardCreditedHighlight=styled.span`
color: ${tertiaryYellow};
font-weight: 400;
font-size: 24px;
line-height: 32px;
@media (max-width: 768px) {
    font-size: 20px;
    line-height: 24px;
}
`
export const CardRenewalFee =styled.span`
font-weight: 400;
font-size: 24px;
line-height: 32px;
color: ${white2};
margin: 32px 0 0 40px;
@media (max-width: 768px) {
    margin: 24px 0 0 16px;
    font-size: 20px;
    line-height: 24px;
}
`
export const CardRenewalAmount = styled.span`
font-weight: 400;
font-size: 32px;
line-height: 24px;
color: ${tertiaryYellow};
margin: 16px 0 0 40px;
@media (max-width: 768px) {
    margin: 8px 0 0 16px;
    font-weight: 500;
    font-size: 24px;
    line-height: 24px;
}
`
export const CardFeeWaived = styled.span`
font-weight: 400;
font-size: 24px;
line-height: 32px;
color: ${white2};
margin: 32px 0 0 40px;
@media (max-width: 768px) {
    margin: 24px 0 0 16px;
    font-size: 20px;
    line-height: 24px;
}
`
export const CardImage = styled.img`
width: 264px;
align-self: flex-end;
@media (max-width: 768px) {
    width: 140px;
}
`